import React from 'react';
import { miniGazelle } from '../../../../../helpers';

const ActiveFilters = ({ activeFilters, clearCurrentFilters, filterProducts, location }) => {
    return (
        <div className="active-filters" data-testid="active-filters">
            <div className="active-filter-tags">
                {activeFilters.map((filter, i) => (
                    <button
                        key={i}
                        className="active-filter-item"
                        data-testid={`active-filter-item-${filter.name}-${filter.option}`}
                        onClick={() => filterProducts(filter.option, filter.name)}
                        aria-label={`Remove filter: ${miniGazelle.label(filter.attributeId, true)} ${filter.option}`}
                    >
                        <p aria-hidden={true} className="filter-name">
                            {miniGazelle.label(filter.attributeId, true)}
                        </p>
                        <p aria-hidden={true} className="filter-option">
                            {filter.option}
                        </p>
                        <div className="remove-filter-btn">✕</div>
                    </button>
                ))}
                {activeFilters.length > 0 && (
                    <button onClick={() => clearCurrentFilters(location)} className="clear-all-btn">
                        Clear all ({activeFilters.length})
                    </button>
                )}
            </div>
        </div>
    );
};

export default ActiveFilters;
